import React from 'react';

const IconTensorflow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#FF6F00"
      d="M14 18h4v4h-4v-4zm0-8h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm-16 16h4v4h-4v-4zm8 0h4v4h-4v-4zm8 0h4v4h-4v-4zm8-8h4v4h-4v-4zm0 8h4v4h-4v-4z"
    />
    <path
      fill="#FFA726"
      d="M18 14v4h-4v-4h4zm8 0v4h-4v-4h4zm0 8v4h-4v-4h4zm8-8v4h-4v-4h4zm0 8v4h-4v-4h4z"
    />
    <path fill="#FF6F00" d="M22 18h4v4h-4v-4zm8 0h4v4h-4v-4zm-8 8h4v4h-4v-4zm8 0h4v4h-4v-4z" />
  </svg>
);

export default IconTensorflow;
